import React from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { ViewError } from '@ui/utils';

interface PageLoaderProps {
  readonly skeleton: React.ReactNode;
  readonly children: React.ReactNode;
  readonly query: UseQueryResult;
}

/** Handles loading and error states for page content. */
export function PageLoader({ skeleton, children, query }: PageLoaderProps) {
  if (query.isLoading) {
    return skeleton;
  }

  if (query.error) {
    return <ViewError error={query.error} />;
  }

  return children;
}
